import { Box, Grid, Typography } from "@mui/material";
import { Link as ReactLink } from "react-router-dom";
import data from "../../Assets/data/energysystems.json";

const ProjectsContainer = () => {
  return (
    <>
      <>
        <Box
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: "2em",
          }}
        >
          <Box
            style={{
              width: "100%",
              background:
                "linear-gradient(180deg, #004C98 0%, rgba(90, 139, 188, 0.646736) 38.69%, rgba(255, 255, 255, 0) 100%)",
            }}
          >
            <Typography
              style={{
                padding: "32px",
                width: "100%",
                justifyContent: "flex-end",
                display: "flex",
                boxSizing: "border-box",
                marginRight: "32px",
              }}
              fontSize="32px"
              fontWeight={600}
            >
              ENERGY SYSTEMS
            </Typography>
          </Box>
          <Box
            style={{
              maxWidth: "960px",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid container>
              {data.map((project, i) => {
                return (
                  <Grid item xs={12} key={i}>
                    <ReactLink
                      to={{ pathname: `/projects/${project.url}` }}
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      <Typography
                        fontWeight={600}
                        fontSize="24px"
                        margin="16px 0px 6px"
                      >
                        {project.title}
                      </Typography>
                    </ReactLink>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Box>
      </>
    </>
  );
};

export default ProjectsContainer;
